import { useCallback, useState } from "react";
import { validateInput } from "../../utils/validations/ajv-input-validation";
import { buildScopedAjvSchema } from "../../utils/validations/ajv-validation-schemas";

export function useValidation<T>(): { errors: Record<string, string> | undefined, validate: (value: T) => boolean, partialValidate: (value: T) => boolean, setSchema: (schema: Record<string, unknown>) => void } {
  const [errors, setErrors] = useState<Record<string, string>>()
  const [schema, setSchema] = useState<Record<string, unknown> | undefined>()
  const validate = useCallback((value: T): boolean => {
    if (!schema) return true
    const res = validateInput(schema, value)
    setErrors(res.errors)
    return res.errors === undefined
  }, [schema])

  /**
   * Validate only the keys that are present in the value object
   */
  const partialValidate = useCallback((value: Partial<T>): boolean => {
    if (!schema) return true
    // Build a scoped schema to only validate the keys that are present in the value object
    const partialSchema = buildScopedAjvSchema(schema, value)
    const res = validateInput(partialSchema, value)
    setErrors(res.errors)
    return res.errors === undefined
  }, [schema])

  return { errors, validate, partialValidate, setSchema }
}
